import React, { useState, Fragment }  from 'react';
import { NavLink } from 'react-router-dom';

// Styles
import { makeStyles } from '@material-ui/core/styles';

import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import Popper from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Divider from '@material-ui/core/Divider';

// Dialog Components
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import MembershipIcon from '@material-ui/icons/VerifiedUser';
import PaymentIcon from '@material-ui/icons/Payment';
import PasswordIcon from '@material-ui/icons/Https';
import SettingsIcon from '@material-ui/icons/Settings';
import LogoutIcon from '@material-ui/icons/ExitToApp';
import AccountIcon from '@material-ui/icons/AccountCircle';

import Loading from 'app/components/loaders/Loading';
import RedButton from 'app/components/buttons/RedButton';

import useApi from 'app/context/useApi';

const useStyles = makeStyles(theme => ({
    popper: {
        zIndex: theme.zIndex.modal
    },
    profilePaper: {
        width: '280px',
        maxWidth: '100%',
        maxHeight: '480px',
        overflowY: 'scroll'
    },

}));

export default function ProfileMenu(props) {

    const { open, anchorRef, onClose } = props;

    const [ verifyLogout, setVerifyLogout ] = useState(false);
    const [ logoutLoading, setLogoutLoading ] = useState(false);

    const api = useApi();
    const classes = useStyles();

    const handleClose = event => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) return;

        onClose();
    };

    const handleListKeyDown = event => {
        if (event.key === 'Tab') {
            event.preventDefault();
            onClose();
        }
    }

    const handleVerifyLogout = () => {
        setVerifyLogout(true);
    }

    const handleLogoutCancel = () => {
        setVerifyLogout(false);
    }

    const handleLogout = () => {

        setLogoutLoading(true);

        const bearerToken = api.defaults.headers.common['Authorization'];
        const token = bearerToken.substr(bearerToken.indexOf(" ") + 1);

        api.delete('/oauth/token/' + token).catch(() => setLogoutLoading(false));
    };

    return (
        <Fragment>
            <Popper
                anchorEl={anchorRef.current}
                open={open}
                onClose={handleClose}
                role={undefined}
                transition
                disablePortal
                className={classes.popper}
                placement='bottom-end'
                >
                {({ TransitionProps }) => (
                    <Grow {...TransitionProps} style={{ transformOrigin: 'right top'}}>
                        <Paper className={classes.profilePaper}>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList
                                    id="profile-menu"
                                    onKeyDown={handleListKeyDown}
                                    >
                                    <MenuItem dense button to='/profile' component={NavLink} >
                                        <ListItemIcon>
                                            <AccountIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="My Profile" />
                                    </MenuItem>
                                    <MenuItem to="/profile/clubs" dense button component={NavLink}>
                                        <ListItemIcon>
                                            <MembershipIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="My Organizations" />
                                    </MenuItem>
                                    <MenuItem to="/profile/payment" dense button component={NavLink}>
                                        <ListItemIcon>
                                            <PaymentIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Payments" />
                                    </MenuItem>
                                    <MenuItem to="/profile/security" dense button component={NavLink}>
                                        <ListItemIcon>
                                            <PasswordIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Security" />
                                    </MenuItem>
                                    <MenuItem to="/profile/settings" dense button component={NavLink}>
                                        <ListItemIcon>
                                            <SettingsIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Settings" />
                                    </MenuItem>
                                    <Divider/>
                                    <MenuItem dense button onClick={handleVerifyLogout}>
                                        <ListItemIcon>
                                            <LogoutIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Logout" />
                                    </MenuItem>
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
            <Dialog
                open={verifyLogout}
                onClose={handleLogoutCancel}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                >
                <Loading isLoading={logoutLoading}/>
                <DialogTitle id="alert-dialog-title">Confirm you want to logout</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to logout? You will be directed back to the login screen.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleLogoutCancel} color="primary" autoFocus>
                        Cancel
                    </Button>
                    <RedButton onClick={handleLogout} variant="contained">
                        Logout
                    </RedButton>
                </DialogActions>
            </Dialog>
        </Fragment>
    )
}
